import { Setter } from "../../services/ComService"
import { LightOrDarkColor } from "../../services/LightOrDarkColor"
import { TagDTO, TagsDTO, TagType } from "./TagDTO"
import TimelineItemDTO, { ITimelineItem } from "./TimelineItemDTO"


export default class TimelineDTO {
  typeId: number
  fromDate: Date = new Date()
  page: number = -1
  items: TimelineItemDTO[] = []
  filterByTagsKind?: TagType
  filterByTags = new TagsDTO()

  constructor(data: ITimeline) {
    this.typeId = data.typeId
    this.filterByTagsKind = data.filterByTagsKind
  }

  public async getFromServer(fromDate: Date, page: number, noCache?: boolean) {
    let startFromBeginning = false
    if (this.filterByTagsKind !== undefined) {
      await this.filterByTags.getFromServerByKind(this.filterByTagsKind)
    }
    if (this.fromDate !== fromDate || this.page !== page) {
      this.fromDate = fromDate
      if (page > 0) {
        startFromBeginning = true
      }
      this.page = page
      const params = {
        typeId: this.typeId,
        fromDate: fromDate,
        page: page,
        startFromBeginning: startFromBeginning,
        tagIDOrList: this.filterByTags.getIds()
      }

      const data = await Setter('timeline/list', params)
      const newItems = data.items.map((i: ITimelineItem) => new TimelineItemDTO(i))
      if (page === 0 || startFromBeginning) {
        this.items = newItems
      } else {
        this.items = [...this.items, ...newItems]
      }
    }
    return this.items
  }

  public getItemPersonDate(personId: number, pointInTime: Date) {
    const result = this.items.find(i => i.isPersonDate(personId, pointInTime))
    return result
  }
  
  public isItemStartDate(personId: number, pointInTime: Date) {
    return !!this.items.find(i => i.isStartDate(personId, pointInTime))
  }

  public isItemEndDate(personId: number, pointInTime: Date) {
    return !!this.items.find(i => i.isEndDate(personId, pointInTime))
  }

  public getTimeClassName(personId: number, pointInTime: Date) {
    const item = this.getItemPersonDate(personId, pointInTime)
    if (!item) { return '' }
    const genericClassName = 'vacation'
    const startClass = this.isItemStartDate(personId, pointInTime) ? 'start' : ''
    const endClass = this.isItemEndDate(personId, pointInTime) ? 'end' : ''
    return [genericClassName, startClass, endClass].filter(c => c).join(' ')
  }

  private getTag(personId: number, pointInTime: Date) {
    const item = this.getItemPersonDate(personId, pointInTime)
    if (!item) { return undefined }
    const tagId = item.getFirstTagId()
    if (tagId !== undefined) {
      return this.filterByTags.getTag(tagId)
    }
  }

  public getTimeName(personId: number, pointInTime: Date) {
    const tag = this.getTag(personId, pointInTime)
    return tag?.name || ''
  }

  public getTimeColor(personId: number, pointInTime: Date) {
    const tag = this.getTag(personId, pointInTime)
    return LightOrDarkColor(tag?.color || '#ffffff') === 'dark' ? '#000000' : '#ffffff'
  }

  public getTimeBgColor(personId: number, pointInTime: Date) {
    const tag = this.getTag(personId, pointInTime)
    return tag?.color || ''
  }

  public async deleteItemByPersonDate(personId: number, date: Date) {
    const item = this.getItemPersonDate(personId, date)
    if (item) {
      await item.delete()
      this.items = this.items.filter(i => i !== item)
    }
  }
}

export interface ITimeline {
  typeId: number,
  filterByTagsKind?: TagType,
}